var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0003 23.3332L25.994 32.4083C25.6523 32.7526 25.0983 32.7526 24.7566 32.4083L21.0003 28.6233M47.6414 21.5046C46.9563 20.5903 46.5756 19.5998 46.4234 18.457L45.8144 14.2665C45.5098 12.057 43.7589 10.3046 41.475 9.92365L37.288 9.31412C36.2222 9.16174 35.1564 8.7046 34.2428 8.09508L30.9693 5.65698C30.0558 4.97127 28.99 4.6665 27.9242 4.6665C26.8584 4.6665 25.7926 4.97127 24.8791 5.65698L21.5294 8.17127C20.6159 8.85698 19.6262 9.23793 18.4843 9.39031L14.3734 9.99984C12.1656 10.3046 10.4147 12.057 10.034 14.3427L9.42501 18.5332C9.27276 19.5998 8.81599 20.6665 8.20696 21.5808L5.69472 24.9332C4.32441 26.7617 4.32441 29.276 5.69472 31.0284L8.20696 34.3808C8.89211 35.2951 9.27276 36.2856 9.42501 37.4284L10.034 41.6189C10.3386 43.8284 12.0895 45.5808 14.3734 45.9617L18.5604 46.5713C19.6262 46.7236 20.692 47.1808 21.6055 47.7903L24.9552 50.3046C26.7823 51.676 29.2945 51.676 31.0455 50.3046L34.3951 47.7903C35.3086 47.1046 36.2983 46.7236 37.4402 46.5713L41.6273 45.9617C43.835 45.657 45.586 43.9046 45.9666 41.6189L46.5756 37.4284C46.7279 36.3617 47.1847 35.2951 47.7937 34.3808L50.3059 31.0284C51.6762 29.1998 51.6762 26.6856 50.3059 24.9332L47.6414 21.5046Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.fe63346995b95c3a87d576880e4312e9.svg";
export { ForwardRef as ReactComponent };